module.exports = __webpack_public_path__ + "img/color_multicolor_a-1629-3@2x.e973d9f.jpg";